import templateUrl from './rs-schedule-sales.component.html'

export const RSScheduleSalesComponent = {
    templateUrl,
    bindings: {
        rsScheduleSales: "<"
    },
    controllerAs: "vm",
    controller: function RSScheduleSalesController($scope) {
        'ngInject'
        const vm = this;

        vm.$onInit = $onInit;

        function $onInit() {
            $scope.$watch("vm.rsScheduleSales", function (oldValues, newValues) {
                if (vm.rsScheduleSales) {
                    vm.summary = calculateSummary(vm.rsScheduleSales);
                }
            }, true);
        }

        function calculateSummary(rsScheduleSales) {
            const summary = rsScheduleSales.reduce(function (sum, sales) {
                sum.salesAmount += sales.SalesAmount;
                sum.approvedHours += sales.ApprovedHours;
                sum.anonymousHours += sales.AnonymousHours;
                sum.totalHours += (sales.ApprovedHours || 0) + (sales.AnonymousHours || 0);
                return sum;
            }, { salesAmount: 0, approvedHours: 0, anonymousHours: 0, totalHours: 0 });
            // Make null if 0.
            summary.salesAmount = summary.salesAmount || null;
            summary.approvedHours = summary.approvedHours || null;
            summary.anonymousHours = summary.anonymousHours || null;
            summary.totalHours = summary.totalHours || null;
            return summary;
        }
    }
}
